import {
    EmailTenantsResult,
} from '../../Models/Api/strongbox.financialportal';

export enum MultiTenantActions {
    MultiTenantLoadPortals = 'MultiTenant/LOAD_PORTALS',
    MultiTenantLoadPortalsComplete = 'MultiTenant/LOAD_PORTALS_COMPLETE',
}

export interface IMultiTenantLoadPortals {
    type: MultiTenantActions.MultiTenantLoadPortals;
    email: string;
    externalId: string;
}

export interface IMultiTenantLoadPortalsComplete {
    type: MultiTenantActions.MultiTenantLoadPortalsComplete;
    email: string;
    externalId: string;
    tenantsResult?: EmailTenantsResult;
}

export type KnownAction =
    IMultiTenantLoadPortals |
    IMultiTenantLoadPortalsComplete;
